import { Alert, AlertTitle, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../features/store.redux';
import { SubscriptionFetch } from '../../features/subscription.feature';
import { useAppDispatch } from '../../hooks';

const SubscribeButton = () => {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const subscription = useAppSelector((state) => state.Subscription.subscription);
    const isLoading = useAppSelector((state) => state.Subscription.isLoading);

    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        dispatch(SubscriptionFetch.GetStatus());
    }, [dispatch]);

    const handleCloseClick = () => {
        setShowPopup(false);
    };

    const handleConfirmClick = () => {
        if (!subscription) return;

        if (subscription.IsSubscribed) {
            dispatch(SubscriptionFetch.Unsubscribe());
        } else {
            dispatch(SubscriptionFetch.Subscribe());
        }

        setShowPopup(false);
    };

    return (
        <div style={{ position: 'relative' }}>
            {subscription && (
                <>
                    <Tooltip
                        title={
                            <Alert severity="info">
                                <AlertTitle>{subscription.IsSubscribed ? 'Unsubscribe from Email Notifications' : 'Subscribe to Email Notifications'}</AlertTitle>
                                <span>
                                    {subscription.IsSubscribed
                                        ? 'You are about to unsubscribe from email notifications. You will no longer receive notifications when a vessel is calling on a port with a medium or high risk of PSC attendance.'
                                        : 'You are about to subscribe to email notifications. You will be notified when a vessel is calling on a port with a medium or high risk of PSC attendance.'}
                                </span>
                            </Alert>
                        }
                        placement="right"
                        arrow
                        sx={{
                            '& .MuiTooltip-tooltip': {
                                backgroundColor: theme.palette.background.paper,
                                color: theme.palette.text.primary,
                                boxShadow: theme.shadows[1],
                                fontSize: '0.875rem'
                            }
                        }}
                    >
                        <Button variant="contained" color="secondary" onClick={() => setShowPopup(true)} sx={{ height: '36px' }} disabled={isLoading}>
                            {subscription.IsSubscribed ? 'Unsubscribe' : 'Subscribe'}
                        </Button>
                    </Tooltip>

                    <Dialog fullScreen={fullScreen} open={showPopup} onClose={handleCloseClick} aria-labelledby="responsive-dialog-title">
                        <DialogTitle id="responsive-dialog-title">{!subscription.IsSubscribed ? 'Subscribe to Email Notifications' : 'Unsubscribe from Email Notifications'}</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {!subscription.IsSubscribed
                                    ? 'You are about to subscribe to email notifications. You will be notified when a vessel is calling on a port with a medium or high risk of PSC attendance.'
                                    : 'You are about to unsubscribe from email notifications. You will no longer receive notifications when a vessel is calling on a port with a medium or high risk of PSC attendance.'}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button autoFocus onClick={handleCloseClick}>
                                Cancel
                            </Button>
                            <Button onClick={handleConfirmClick} autoFocus>
                                {!subscription.IsSubscribed ? 'Subscribe' : 'Unsubscribe'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            )}
        </div>
    );
};

export default SubscribeButton;
